import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/symptomsSlice";

import symptomsApis from "src/api/symptoms";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

const getSymptomsSaga = function* getSymptomsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      symptomsApis.getSymptoms,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getSymptomsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getSymptomsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const getPSPSymptomsSaga = function* getPSPSymptomsSaga({
  payload: { resolve, reject, payload, query_params },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      symptomsApis.getPSPSymptoms,
      payload,
      query_params
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getPSPSymptomsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getPSPSymptomsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* offersSaga() {
  yield all([
    takeEvery(actions.getSymptomsRequest, getSymptomsSaga),
    takeEvery(actions.getPSPSymptomsRequest, getPSPSymptomsSaga),
  ]);
}
